import getStore from 'Util/Store';

/* eslint-disable func-names */
/* eslint-disable fp/no-let */
/* eslint-disable no-undef */
// eslint-disable-next-line import/no-mutable-exports
export let isEdroneInitialized = false;

/** @namespace Satisfly/Util/Edrone/Index/initEdrone */
export const initEdrone = () => {
    if (isEdroneInitialized) {
        return;
    }

    isEdroneInitialized = true;

    (function (srcjs) {
        window._edrone = window._edrone || {};
        _edrone.app_id = getStore().getState().ConfigReducer?.edrone_app_id ?? '67724bc452a93';
        _edrone.platform = 'universal';
        const doc = document.createElement('script');
        doc.type = 'text/javascript';
        doc.async = true;
        doc.src = (document.location.protocol === 'https:' ? 'https:' : 'http:') + srcjs;
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(doc, s);
    }(`//d3bo67muzbfgtl.cloudfront.net/edrone_2_0.js?app_id=${getStore().getState().ConfigReducer?.edrone_app_id}`));
};
